export default {
  atoms: {
    adSlot: {
      adLabel: 'Anuncio'
    },
    authSupportCopy: {
      copy: '¿Necesitas más ayuda? Podemos ayudarte.',
      action: 'Envíanos un correo a'
    },
    premiumIdentifier: {
      iconText: 'Premium'
    },
    recaptchaCopy: {
      agreeLineOne: 'Este sitio web está protegido por reCAPTCHA y Google',
      agreeLineTwo: 'política de privacidad',
      agreeLineThree: 'y',
      agreeLineFour: 'Términos de servicios',
      agreeLineFive: 'aplicar.',
      ariaLabel: {
        privacy: 'política de privacidad',
        terms: 'Términos de servicios'
      }
    },
    termsAndConditions: {
      agreeLineOne: 'Creando esta cuenta, estás aceptando los',
      agreeLineTwo: 'términos',
      agreeLineThree: 'y',
      agreeLineFour: 'política de privacidad',
      agreeLineFive: 'Burda International. Si no deseas recibir más correos electrónicos de nuestra parte, puedes darte de baja en cualquier momento. ',
      ariaLabel: {
        privacy: 'política de privacidad',
        terms: 'términos y condiciones'
      }
    },
    time: {
      formatTimeHours_one: '{{hours}} h',
      formatTimeHours_few: '{{hours}} h',
      formatTimeHours_many: '{{hours}} h',
      formatTimeHours_other: '{{hours}} h',
      formatTimeHours: '{{hours}} h',
      formatTimeHours_plural: '{{hours}} h',
      formatTimeHours_0: '{{hours}} h',
      formatTimeHours_1: '{{hours}} h',
      formatTimeHours_2: '{{hours}} h',
      formatTimeMins_one: '{{minutes}} min',
      formatTimeMins_few: '{{minutes}} min',
      formatTimeMins_many: '{{minutes}} min',
      formatTimeMins_other: '{{minutes}} min',
      formatTimeMins: '{{minutes}} min',
      formatTimeMins_plural: '{{minutes}} min',
      formatTimeMins_0: '{{minutes}} min',
      formatTimeMins_1: '{{minutes}} min',
      formatTimeMins_2: '{{minutes}} min'
    },
    instagramEmbed: {
      viewPostOnInstagram: 'Ver publicación en Instagram'
    }
  },
  molecules: {
    accountNav: {
      defaultLabel: 'Mi cuenta',
      registerText: 'Registrarse',
      signInText: 'Iniciar sesión',
      ariaLabel: {
        account: 'Cuenta'
      }
    },
    adBanner: {
      ariaLabel: {
        dismissText: 'Cerrar anuncio'
      }
    },
    ageVerificationModal: {
      title: 'Verificación de edad',
      intro: 'Este sitio web contiene contenido apto sólo para adultos',
      deny: 'No tengo [ageLimit] años',
      confirm: 'Tengo más de [ageLimit] años',
      moreInfo: 'Más información',
      remember: 'Recuérdame'
    },
    authDropDown: {
      registerText: 'Registrarse',
      signInText: 'Iniciar sesión'
    },
    batchedGrid: {
      showingItemsText: 'Mostrar elemento 1 de {{nItemsShown}} de {{nItems}}',
      viewMoreButtonText: 'Ver más',
      showMoreButtonsText: 'Mostrar más'
    },
    cookAndPrepTime: {
      sr: {
        timeRange: 'Tiempo de elaboración y cocción'
      },
      timeRange: {
        cook: 'Cocción',
        prep: 'Elaboración',
        total: 'Tiempo total'
      }
    },
    eyebrowNav: {
      ariaLabel: {
        quickLinks: 'Enlaces rápidos'
      }
    },
    formAutoComplete: {
      ariaLabel: {
        noResult: 'Ningún resultado',
        search: 'Buscar'
      }
    },
    formImageUpload: {
      button: {
        loadPrompt: 'Pulsa o haz click para añadir la imágen',
        loadPromptRequired: 'obligatorio',
        loadPromptOptional: 'opcional',
        ownImage: 'Por favor comprueba que esta es tu propia imagen',
        remove: 'Quitar',
        rotateLeft: 'Girar hacia la izquierda',
        rotateRight: 'Girar hacia la derecha',
        save: 'Guardar'
      },
      error: {
        maxFileSize: 'El tamaño del fichero es demasiado grande, por favor sube un archivo que no supere los {(maxFileSize}}MB',
        minHeight: 'La imagen no cumple los requisitos mínimos de pixels {{minDimensions}} de altura',
        minWidth: 'La imagen no cumple los requisitos mínimos de pixels {{minDimensions}} de ancho'
      }
    },
    formMultiSelect: {
      ariaLabel: {
        formInput: 'Filtro {{label}}'
      },
      filterOptions: {
        noResult: 'Ningún resultado',
        selectAllLabel: 'Selecciona todo',
        inputPlaceholderSelect: 'Selecciona...',
        inputPlaceholderSelected: 'seleccionado'
      },
      sr: {
        optionsButton: 'Mostrar/ocultar opciones'
      }
    },
    formSortableInputs: {
      ariaLabel: {
        deleteInput: 'Borrar',
        grab: 'Presiona y arrastra para mover la entrada'
      }
    },
    formSubmitButton: {
      button: {
        savedText: 'Guardado',
        savingText: 'Guardando'
      }
    },
    gallery: {
      ariaLabel: {
        fullScreen: 'apre galería de imágenes en pantalla completa'
      },
      imgCountText: '{{slideCount}} de {{images}}'
    },
    glossaryNav: {
      ariaLabel: {
        nav: 'glosario'
      }
    },
    heightClamper: {
      button: {
        expandTextMore: 'Mostrar más',
        expandTextLess: 'Mostrar menos'
      }
    },
    ingredientsList: {
      heading: 'Ingredientes'
    },
    inlineGallery: {
      imageCount: '{{imageCount}} de {{totalImages}}'
    },
    keyValueBlocks: {
      keyHeader: 'Clave',
      prefixHeader: 'Resaltar',
      valueHeader: 'Valor'
    },
    lightBox: {
      ariaLabel: {
        close: 'cerrar'
      }
    },
    loadingIcon: {
      sr: {
        icon: 'Cargando'
      }
    },
    loadingState: {
      "default": {
        heading: 'Un momento, por favor...'
      },
      createAccount: {
        heading: '¡Espera un momento por favor!',
        subHeading: 'Estamos creando tu cuenta'
      }
    },
    methodList: {
      methodLabel: 'Preparación',
      counterPrefix: 'Paso'
    },
    modal: {
      ariaLabel: {
        close: 'Cerrar ventana'
      }
    },
    numericPaginator: {
      icon: {
        prev: 'Anterior',
        next: 'Siguiente'
      },
      sr: {
        icon: 'Página',
        nav: 'Actualmente usted está en la página {{page}}'
      }
    },
    passwordCriteria: {
      ariaLabel: {
        notSatisfied: 'no está satisfecho',
        satisfied: 'está satisfecho'
      },
      config: {
        bothCase: 'Letras mayúsculas y minúsculas',
        lowerCase: 'Letras minúsculas',
        minLength_one: 'Al menos {{minLength}} carácter',
        minLength_few: 'Al menos {{minLength}} caracteres',
        minLength_many: 'Al menos {{minLength}} caracteres',
        minLength_other: 'Al menos {{minLength}} caracteres',
        minLength: 'Al menos {{minLength}} carácter',
        minLength_plural: 'Al menos {{minLength}} caracteres',
        minLength_0: 'Al menos {{minLength}} carácter',
        minLength_1: 'Al menos {{minLength}} caracteres',
        minLength_2: 'Al menos {{minLength}} caracteres',
        requireDigit: 'Un número (i.e. 0–9)',
        symbol: 'Un símbolo (por ejemplo: !, ?, @)',
        upperCase: 'Letras mayúsculas'
      },
      passwordContain: {
        text: 'Su contraseña debe incluir'
      },
      sr: {
        passwordContain: 'Su contraseña debe incluir:'
      }
    },
    passwordInput: {
      buttonText: {
        hide: 'OCULTAR',
        show: 'MOSTRAR'
      },
      formLabel: 'Contraseña',
      placeholder: 'Introduzca su contraseña',
      sr: {
        strength: 'El grado de vulnerabilidad de su contraseña es {{passwordStrength}}',
        visibility: {
          hidden: 'Contraseña oculta',
          shown: 'Contraseña visible'
        }
      }
    },
    plantOverview: {
      averageYield: 'Rendimiento Medio',
      depth: 'Profundidad:',
      size: 'Tamaño de la planta:',
      spacing: 'Espaciado:',
      spacingApart: '{{spacingApart}} entre',
      spacingBetween: '{{spacingBetweenRows}} entre filas'
    },
    popupToggleButton: {
      ariaLabel: {
        toggle: 'Toggle {{popup}} popup'
      }
    },
    postContentStream: {
      ariaMessage: {
        itemsAdded: 'Nuevos elementos añadidos en',
        singleItemAdded: 'Nuevo elemento añadido en'
      }
    },
    postTeaser: {
      readMore: 'Leer más',
      publishDate: 'Publicado: {{published}}'
    },
    rate: {
      sr: {
        legend: '¿Cuál es tu puntuación sobre {{bestRating}}?',
        outOf: 'sobre',
        star_one: 'estrella',
        star_few: 'estrellas',
        star_many: 'estrellas',
        star_other: 'estrellas',
        star: 'estrella',
        star_plural: 'estrellas',
        star_0: 'estrella',
        star_1: 'estrellas',
        star_2: 'estrellas'
      }
    },
    rating: {
      ariaLabel: {
        rating: 'puntuación'
      },
      countText: '{{count}} {{label}}',
      types: {
        rating_one: 'puntuación',
        rating_few: 'puntuaciones',
        rating_many: 'puntuaciones',
        rating_other: 'puntuaciones',
        rating: 'puntuación',
        rating_plural: 'puntuaciones',
        rating_0: 'puntuación',
        rating_1: 'puntuaciones',
        rating_2: 'puntuaciones',
        review_one: 'reseña',
        review_few: 'reseñas',
        review_many: 'reseñas',
        review_other: 'reseñas',
        review: 'reseña',
        review_plural: 'reseñas',
        review_0: 'reseña',
        review_1: 'reseñas',
        review_2: 'reseñas'
      },
      inlineRateText: 'Puntúa',
      skeletonRateText: 'Puntúa'
    },
    ratingsCriteria: {
      overallLabel: 'Puntuación total'
    },
    searchForm: {
      ariaLabel: {
        performSearch: 'Buscar',
        resetButton: 'Resetear input'
      }
    },
    sideBarNav: {
      ariaLabel: {
        settings: 'Mi configuración',
        verticalNav: 'Lado'
      }
    },
    socialShare: {
      sr: {
        iconEmail: 'Email a un amigo',
        iconShare: 'Compartir en {{platform}}'
      }
    },
    socialSignInButton: {
      signUpWithButtonText: 'Crear cuenta con',
      continueWithButtonText: 'Continuar con'
    },
    tableClamper: {
      collapseButtonText: 'Mostrar menos',
      expandButtonText: 'Mostrar más'
    },
    truncatedIcons: {
      tooltipLabel: 'más'
    }
  },
  organisms: {
    emailSentConfirmation: {
      accountVerificationHeading: 'Hemos enviado un email de verificación a',
      passwordResetHeading: 'Si tienes una cuenta, recibirás un email para restablecer tu contraseña.',
      resendEmailCopy: '¿No recibiste el email?',
      bodyCopy: 'Asegúrate de revisar todas las carpetas en tu bandeja de entrada, incluyendo la de correo no deseado.',
      resendEmailButton: 'Haz click para reenviar',
      supportEmailSubject: 'Necesito ayuda para verificar mi cuenta.'
    },
    cardBuilder: {
      ariaLabel: {
        mediaImage: 'Ver {{title}}'
      },
      offerCodeText: 'usar código: {{offerCode}}'
    },
    cardCarouselSection: {
      errorMessage: '¡Vaya! Algo salió mal al cargar los datos. Por favor, intenta otra opción.',
      formLabel: 'Opciones',
      infoMessage: 'Lo sentimos, no hay más datos disponibles',
      slidesToShowItems: 'Mostrando elementos {{currentSlide}} a {{nextSlides}} de {{allSlides}}',
      slidesToShowItem: 'Mostrando elemento {{currentSlide}} de {{allSlides}}'
    },
    carousel: {
      sr: {
        iconStack: '{{direction}} elemento',
        paging: 'Página {{pageNumber}}'
      }
    },
    resetPasswordForm: {
      headingCopy: 'Mi cuenta:',
      submitButton: 'Enviar contraseña'
    },
    collection: {
      ariaLabel: {
        edit: 'Editar',
        registerButton: 'Registrar',
        share: 'Compartir',
        signinButton: 'Iniciar sesión'
      },
      author: 'Por {{author}}',
      signinLinkText: 'Iniciar sesión',
      signInLinkTitle: 'Iniciar sesión',
      signInPromptLineOne: '¿Es esta su colección?',
      signInPromptLineTwo: 'por editar'
    },
    dynamicAccordian: {
      nextLabel_one: 'Mostrar el siguiente elemento {{count}}',
      nextLabel_few: 'Mostrar {{count}} elementos siguientes',
      nextLabel_many: 'Mostrar {{count}} elementos siguientes',
      nextLabel_other: 'Mostrar el siguiente elemento {{count}}',
      nextLabel: 'Mostrar el siguiente elemento {{count}}',
      nextLabel_plural: 'Mostrar el siguiente elemento {{count}}',
      nextLabel_0: 'Mostrar el siguiente elemento {{count}}',
      nextLabel_1: 'Mostrar el siguiente elemento {{count}}',
      nextLabel_2: 'Mostrar el siguiente elemento {{count}}',
      previousLabel_one: 'Mostrar el elemento anterior {{count}}',
      previousLabel_few: 'Mostrar {{count}} elementos anteriores',
      previousLabel_many: 'Mostrar {{count}} elementos anteriores',
      previousLabel_other: 'Mostrar el elemento anterior {{count}}',
      previousLabel: 'Mostrar el elemento anterior {{count}}',
      previousLabel_plural: 'Mostrar el elemento anterior {{count}}',
      previousLabel_0: 'Mostrar el elemento anterior {{count}}',
      previousLabel_1: 'Mostrar el elemento anterior {{count}}',
      previousLabel_2: 'Mostrar el elemento anterior {{count}}'
    },
    embeddedPost: {
      ariaLabel: {
        viewArticle: 'Ver {{title}}'
      }
    },
    filters: {
      ariaLabel: {
        activeFilters: 'Filtros activos',
        closeFilters: 'Cerrar la barra lateral de filtros',
        refine: 'Cerrar la barra lateral de filtros',
        showMoreFilters: 'Mostrar más filtros',
        clearFiltersText: 'Borrar todos los filtros'
      },
      button: {
        clearFiltersText: 'Borrar',
        refineText: 'Refinar',
        showMoreFiltersText: 'Más filtros',
        closeText: 'Cerrar'
      },
      clearAll: 'Borrar todos',
      refineText: 'Refinar tus resultados',
      yourFilters: 'Tus filtros:',
      sr: {
        closeFilters: 'Cerrar la barra lateral de filtros'
      }
    },
    listPage: {
      showMoreButtonsText: 'Cargar más'
    },
    liveBlog: {
      errorMessage: 'Lo sentimos, algo ha ido mal al cargar más elementos, por favor prueba otra vez.',
      isLiveUpdatedText: 'DIRECTO actualizado {{duration}}',
      liveIconTitle: 'directo',
      liveKickerTitle: 'Directo',
      loadMoreButtonText: 'Cargar más',
      notLiveUpdatedText: 'Actualizado {{duration}}',
      statusText: 'La cobertura en directo de este evento ha concluido.',
      time: {
        lessThanOneHour_one: 'Hace {{count}} minuto',
        lessThanOneHour_few: 'Hace {{count}} minutos',
        lessThanOneHour_many: 'Hace {{count}} minutos',
        lessThanOneHour_other: 'Hace {{count}} minutos',
        lessThanOneHour: 'Hace {{count}} minuto',
        lessThanOneHour_plural: 'Hace {{count}} minutos',
        lessThanOneHour_0: 'Hace {{count}} minuto',
        lessThanOneHour_1: 'Hace {{count}} minutos',
        lessThanOneHour_2: 'Hace {{count}} minutos',
        lessThanOneMinute: 'Hace menos de 1 minuto',
        moreThanHour_one: 'Hace {{count}} hora',
        moreThanHour_few: 'Hace {{count}} horas',
        moreThanHour_many: 'Hace {{count}} horas',
        moreThanHour_other: 'Hace {{count}} horas',
        moreThanHour: 'Hace {{count}} hora',
        moreThanHour_plural: 'Hace {{count}} horas',
        moreThanHour_0: 'Hace {{count}} hora',
        moreThanHour_1: 'Hace {{count}} horas',
        moreThanHour_2: 'Hace {{count}} horas'
      }
    },
    loginLanding: {
      button: {
        loginText: 'Inicie sesión con su email'
      },
      link: {
        createAccountText: 'Crear cuenta'
      },
      dividerText: 'O',
      newHereText: '¿Nuevo por aquí?',
      loginHeaderText: 'Hola de nuevo. Te hemos echado de menos, nos alegra que hayas vuelto.'
    },
    loginForm: {
      emailLabel: 'Email',
      emailPlaceholder: 'Introduzca su email',
      loginFormHeaderText: 'Introduce tus datos para iniciar sesión en tu cuenta',
      button: {
        loginText: 'Iniciar sesión'
      },
      link: {
        forgotPasswordText: '¿Olvidaste tu contraseña?'
      },
      submissionError: {
        message: 'Su email y/o contraseña son incorrectos. Por favor, pruebe otravez o seleccione Olvidé contraseña'
      }
    },
    mainNav: {
      ariaLabel: {
        main: 'Principal'
      },
      sr: {
        tierThreeBack: 'Volver a',
        tierTwoBack: 'Volver a'
      }
    },
    marketingPreferencesForm: {
      button: {
        saveMyPreferencesText: 'Guardar mis preferencias'
      },
      checkbox: {
        label: 'Si, apúntame'
      },
      heading: '¿Te gustaría recibir ofertas de {{brand}} y su editor Immediate Media Company Limited?',
      notification: {
        error: 'No hemos podido guardar tus preferencias. Por favor, visita Mi Cuenta y actualiza tus ajustes.'
      }
    },
    newsLetterSignUp: {
      input: {
        emailPlaceholder: 'Dirección de email'
      }
    },
    post: {
      ariaLabel: {
        calloutButtonEdit: 'Editar',
        calloutButtonPublish: 'Publicar'
      },
      productSpec: {
        collapseButtonText: 'Menos detalles',
        expandButtonText: 'Más detalles',
        headline: 'Especificaciones del producto',
        skip: 'Saltar para ver especificaciones del producto'
      },
      sr: {
        sponsoredHeading: 'Contenido promocionado'
      }
    },
    postHeader: {
      button: {
        dealsText: 'Saltar para ver detalles',
        print: 'Imprimir'
      },
      itemCount: {
        items_one: 'elemento',
        items_few: 'elementos',
        items_many: 'elementos',
        items_other: 'elementos',
        items: 'elemento',
        items_plural: 'elementos',
        items_0: 'elemento',
        items_1: 'elementos',
        items_2: 'elementos'
      },
      ourRatingText: 'Nuestra puntuación',
      publishDate: 'Publicado: {{published}}'
    },
    reaction: {
      ariaLabel: {
        "delete": 'Eliminar'
      },
      button: {
        replyText: 'Responder',
        reportText: 'Reportar'
      },
      removedText: 'Esto ha sido eliminado'
    },
    registrationForm: {
      createText: 'Crear una cuenta',
      emailPlaceholder: 'Introduzcas tu email',
      srButton: 'botón.',
      emailLabel: 'Email'
    },
    registrationLanding: {
      ariaLabel: {
        signUpText: 'Haz clic aquí para registrarte con tu correo electrónico'
      },
      button: {
        signUpText: 'Registrar con email'
      },
      link: {
        loginText: 'Iniciar sesión'
      },
      dividerText: 'O',
      alreadyRegisteredText: '¿Ya registrado?',
      registrationHeaderText: 'Crea tu cuenta de {{brand}} y recibe nuestros boletines exclusivos por email.'
    },
    forgotPasswordForm: {
      formCopy: 'Introduce tu dirección de correo electrónico registrada y te ayudaremos a restablecer tu contraseña',
      emailLabel: 'Email',
      emailPlaceholder: 'Introduzca su email',
      resetPasswordButtonText: 'Resetear contraseña'
    },
    reviewSummary: {
      heading: 'Lo que hemos testeado'
    },
    roastCalculator: {
      button: {
        resetText: 'Reseteo'
      },
      imperialLabel: 'Imperial',
      metricLabel: 'Sistema Métrico',
      sr: {
        imperialValueOunces: 'Medida imperial en onzas',
        imperialValuePounds: 'Medida imperial en libras',
        metricConverterLabel: 'Valor métrico en {{converter}}',
        metricConverterUnit: '{{converter}} unidad',
        selectMeat: 'Selecciona tipo de carne'
      },
      meat: {
        beefMedium: 'Ternera (punto medio)',
        beefRare: 'Ternera (poco hecha)',
        beefWellDone: 'Ternera (muy hecha)',
        chicken: 'Pollo',
        duck: 'Pato',
        goose: 'Ganso',
        lambMedium: 'Cordero (punto medio)',
        lambRare: 'Cordero (poco hecho)',
        lambWellDone: 'Cordero (muy hecho)',
        pork: 'Cerdo',
        turkey: 'Pavo',
        venisonMedium: 'Venado (punto medio)',
        venisonRare: 'Venado (poco hecho)',
        venisonWellDone: 'Venado (muy hecho)'
      }
    },
    searchResults: {
      button: {
        loadPrevious: 'Anteriores',
        loadNext: 'Siguientes'
      },
      showingItems: 'Mostrando resultados {{from}} de {{to}} de {{total}}',
      noResults: 'Lo sentimos, algo ha fallado al cargar los resultados de tu búsqueda. Por favor vuelve a intentarlo.'
    },
    siteFooter: {
      privacyItemLabel: 'Ajustes de privacidad',
      privacyItemTitle: 'Configurar ajustes de privacidad y consentimiento'
    },
    verificationError: {
      errorWithRetrySignUpCopy: 'Lo sentimos, hemos encontrado un problema al intentar verificar tu cuenta. Vuelve a registrarte o contacta con soporte.',
      errorWithResendEmailCopy: 'Lo sentimos. Vuelve a hacer click en el enlace para enviar un nuevo correo de verificación.',
      linkExpiredWithResendEmailCopy: 'El enlace que te hemos enviado ya no es válido. Es una medida de seguridad para tu cuenta. Haz click en el enlace para enviar un nuevo correo de verificación.',
      supportEmailSubject: 'Necesito ayuda para verificar mi cuenta'
    },
    weightVolumeConverter: {
      ariaLabel: {
        imperialValue: 'Valor en sistema imperial {{units}}',
        imperialValueOther: 'Valor en sistema imperial {{units}}',
        metricUnitText: 'Selección de unidad métrica',
        metricValueText: 'Valor en sistema imperial'
      },
      sr: {
        imperialValue: 'Valor en sistema imperial {{units}}',
        imperialValueOther: 'Valor en sistema imperial {{units}}',
        metricUnitText: 'Unidad de medida en sistema métrico',
        metricValueText: 'Unidad de valor en sistema métrico'
      },
      volumeText: 'Volumen',
      weightText: 'Peso'
    }
  },
  templates: {
    searchPage: {
      title: 'Resultados de tu búsqueda',
      noResults: 'Lo sentimos, no hemos encontrado ningún resultado. Por favor, prueba a actualizar tu búsqueda.',
      error: 'Lo sentimos, no se han podido cargar los resultados de tu búsqueda.',
      sort: 'Ordenar'
    }
  }
};